import {formatCPF, formatCNPJ, formatCurrency} from '@brazilian-utils/brazilian-utils';
import axios from 'axios';

import { format as dateFnsFormat, parseISO } from 'date-fns';

export const formatMoney = (int) => {
  let tmp = int + '',
    neg = false;

  if (tmp.indexOf("-") === 0) {
    neg = true;
    tmp = tmp.replace("-", "");
  }

  if (tmp.length === 1) tmp = "0" + tmp

  tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
  if (tmp.length > 6)
    tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

  if (tmp.length > 9)
    tmp = tmp.replace(/([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2,$3");

  if (tmp.length > 12)
    tmp = tmp.replace(/([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2.$3,$4");

  if (tmp.indexOf(".") === 0) tmp = tmp.replace(".", "");
  if (tmp.indexOf(",") === 0) tmp = tmp.replace(",", "0,");

  return (neg ? (''.concat('-', 'R$ ', tmp)) : (''.concat('R$ ', tmp)));
}

export const debounceFunc = debounceEvent();
function debounceEvent(time_key_up) {
  return (fn, wait = 1000) => clearTimeout(time_key_up, time_key_up = setTimeout(() => fn(), wait));
}

export function checkCurrentDate(year, month, day) {
  const currentDate = new Date().toDateString();
  const date = new Date(year, month, day).toDateString();

  if (currentDate === date)
    return true;

  return false;
}

export function formatPaymentEvent(payment_type, payment_mode) {
  switch (payment_type) {
    case 'CreditCard':
      return "Cartão de Crédito Online";
    case 'Boleto':
      return 'Boleto';
    case 'Pix':
      return 'Pix';
    case 'Lio':
      switch (payment_mode) {
        case 'CreditCard':
          return "Cartão de Crédito Presencial";
        case 'DebitCard':
          return "Cartão de Débito Presencial";
        default:
          return "";
      }
    default:
      return "";
  }
}

export function formatTransaction(value) {
  switch (value) {
    case 1:
      return 'Autorizado';
    case 2:
      return 'Capturado'
    case 3:
      return 'Negado'
    case 10:
      return 'Cancelado no mesmo dia'
    case 11:
      return 'Cancelado'
    default:
      return 'Desconhecido'
  }
}

export const paymentMethodStatus = {
  PaymentApproved: 'Pago',
  BoletoGenerated: 'Boleto Gerado',
  BoletoExchanged: 'Boleto Substituído',
  PixGenerated: 'Pix Gerado',
  PixExchanged: 'Pix Substituído',
  Overdue: 'Pix Expirado',
  PaidByOther: 'Pago por outro meio',
};

export const installmentsStatus = {
  Paid: 'Parcela paga',
  Open: 'Parcela em aberto',
  Overdue: 'Parcela em atraso',
  PaidByOther: 'Pago por outro meio',
};

export const backgroundInstallmentsStatus = {
  Paid: '#EDF7ED',
  Open: '#E5F6FC',
  Overdue: '#FDECED',
  PaidByOther: '#EDF7ED',
};

export const backgroundPaymentMethodStatus = {
  PaymentApproved: '#EDF7ED',
  BoletoGenerated: '#E5F6FC',
  PixGenerated: '#E5F6FC',
  BoletoExchanged: '#FDECED',
  PixExchanged: '#FDECED',
  Overdue: '#FDECED',
  PaidByOther: '#EDF7ED',
};


export function formatReportsStatus(value) {
  switch (value) {
    case 'CREATING':
      return 'PREPARANDO';
    case 'GENERATING':
      return 'GERANDO';
    case 'GENERATED':
      return 'GERADO';
    case 'FAILED':
      return 'ERRO';
    default:
      return "Desconhecido";
  }
}

export const paymentTypes = {
  CreditCard: 'CreditCard',
  DebitCard: 'DebitCard',
  Boleto: 'Boleto',
};

export const paymentTypesDesc = {
  CreditCard: 'Cartão de crédito online',
  Lio: 'Cartão presencial',
  Boleto: 'Boleto',
};

export const transactionStatusType = (status, _void) => {
  switch (status) {
    case 2: return _void ? 'Estorno Parcial' : 'Capturado';
    case 10: return 'Cancelado';
    case 11: return 'Estornado'
    default: return '';
  }
};

export function formatDocument({type, number}) {
  switch (type.toUpperCase()) {
    case 'CPF': return formatCPF(number);
    case 'CNPJ': return formatCNPJ(number);
    default: return '';
  }
}

export function formatUserStatus(value) {
  switch (value) {
    case true: return 'Ativo'
    case false: return 'Inativo'
    default: return '';
  }
}

export function formatUserLevel(value) {
  switch (value) {
    case true: return 'Administrador'
    case false: return 'Usuário'
    default: return '';
  }
}

export function convertToCurrency(value = 0) {
  return `R$ ${formatCurrency(value / 100)}`;
}

export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return;
  }
  return phoneNumber.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3');
}

export function compareDate(data) {
  const dataStr = data;
    const dataLimpa = dataStr.split('às')[0].trim();

    const partesData = dataLimpa.split('/');
    const dia = parseInt(partesData[0], 10);
    const mes = parseInt(partesData[1] - 1, 10);
    const ano = parseInt(partesData[2], 10);

    const dataFormatada = new Date(ano, mes, dia);
    const dataAtual = new Date();

    const isDataMaiorQueAtual = dataFormatada > dataAtual;
    return isDataMaiorQueAtual;
}

export const planStatus = {
  Creating: 'Criando',
  Created: 'Criado',
  CreationError: 'Erro na criação',
  Canceled: 'Cancelado',
  Concluded: 'Concluído',
};

export const documentType = {
  CPF: 'CPF',
  CNPJ: 'CNPJ'
}

export const uploadFile = async (url, fields, file) => {
  const formData = new FormData();

  if (fields) {
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v));
  }

  formData.append('file', file);

  return axios.post(url, formData).then(d => d.data);
};


export const formatDateUTC = (date) => {
  return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
}


export const formatDates = (dateRange) => {
  const [startDate, endDate] = dateRange.split('/');

  const formattedStartDate = dateFnsFormat(parseISO(startDate), 'dd/MM/yyyy');
  const formattedEndDate = dateFnsFormat(parseISO(endDate), 'dd/MM/yyyy');

  return `${formattedStartDate} - ${formattedEndDate}`;
};

export const formatIdentity = (value) => {
  if (!value) return '';

  const documentNumber = value.replace(/\D/g, '');
  return documentNumber.length === 11
    ? formatCPF(documentNumber)
    : formatCNPJ(documentNumber);
};